import { VendedoresSemAgendamentoComponent } from './pages/vendedores-sem-agendamento/vendedores-sem-agendamento.component';
import { ModuleWithProviders } from "@angular/core";
import { RouterModule } from "@angular/router";

import { RootComponent } from "./root/root.component";

import { VisitaHomeComponent } from "./pages/home/home.component";
import { CadastroComponent } from "./pages/cadastro/cadastro.component";
import { ControleComponent } from "./pages/controle/controle.component";
import { ProximosComponent } from "./pages/proximos/proximos.component";
import { HistoricoComponent } from "./pages/historico/historico.component";

import { AuthGuard } from "@core/guards/auth.guard";
import { EdicaoComponent } from "./pages/edicao/edicao.component";
import { DebitoAbertoCarteiraInfoComponent } from './pages/cadastro/modals/debito-aberto-carteira-info/debito-aberto-carteira-info.component';
import { VendedorComAgendamentoComponent } from './pages/vendedor-com-agendamento/vendedor-com-agendamento.component';
import { StatusSemAgendamentoComponent } from './pages/status-sem-agendamento/status-sem-agendamento.component';
import { ControleClienteAtivoSemanaComponent } from './pages/controle-cliente-ativo-semana/controle-cliente-ativo-semana.component';
import { ControleFeriadoComponent } from './pages/controle-feriado/controle-feriado.component';
import { HistoricoReagendamentoComponent } from './pages/historico-reagendamento/historico-reagendamento.component';

export const routing: ModuleWithProviders = RouterModule.forChild([
  { 
    path: "debito-aberto-carteira-info", component: DebitoAbertoCarteiraInfoComponent 
  },
  {
    path: "visitas",
    component: RootComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "", component: VisitaHomeComponent },
      { path: "home", component: VisitaHomeComponent },
      { path: "controle", component: ControleComponent },
      { path: "controle/proximos", component: ProximosComponent },
      { path: "vendedores-sem-agendamento", component: VendedoresSemAgendamentoComponent },
      { path: "vendedores-com-agendamento", component: VendedorComAgendamentoComponent },
      { path: "cadastro", component: CadastroComponent },
      { path: "historico", component: HistoricoComponent },
      { path: ":idCliente/:idSetor/:idFilial/:dataPrev/edit", component: EdicaoComponent },
      { path: ":idCliente/:idSetor/:idFilial/:dataPrev/detail", component: EdicaoComponent },
      { path: "status-sem-agendamento", component: StatusSemAgendamentoComponent },
      { path: "controle-cliente-ativo-semana", component: ControleClienteAtivoSemanaComponent },
      { path: "controle-feriado", component: ControleFeriadoComponent },
      // { path: "debito-aberto-carteira-info", component: DebitoAbertoCarteiraInfoComponent },
      { path: "planejamento", component: EdicaoComponent  },
      { path: "historico-reagendamento", component: HistoricoReagendamentoComponent  }
    ]
  }
  
]);
